import { RaffleDealStoreCtx } from '@/stores/RaffleDealStore';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';

import RaffleDealDrawBody from '../Draw/RaffleDealDrawBody';
import RaffleDealHistoryBody from '../History/RaffleDealHistoryBody';
import Tab from '../Tab/RaffleDealTab';

const RaffleDealBody: React.FC = () => {
  const store = useContext(RaffleDealStoreCtx);

  return (
    <section>
      <Tab />
      {store.activeTab === 'DRAW' && <RaffleDealDrawBody />}
      {store.activeTab === 'HISTORY' && <RaffleDealHistoryBody />}
    </section>
  );
};

export default observer(RaffleDealBody);
